(function() {
  'use strict';

  /**
   * Service pour récupérer les données du glossaire
   */
  angular
    .module('observatoireApp')
    .service('GlossaireService', ['$http', '$q', '$sce', GlossaireService]);

  function GlossaireService($http, $q, $sce) {
    var service = {
      getGlossaireContent: getGlossaireContent,
      parseGlossaireContent: parseGlossaireContent
    };

    return service;

    /**
     * Récupère le contenu du glossaire depuis l'URL externe
     * @returns {Promise} Promesse contenant les données du glossaire
     */
    function getGlossaireContent() {
      var deferred = $q.defer();

      // URL de la page d'aide contenant le glossaire
      var url = 'https://www.observatoire.td/help';
      
      // Utilisation de $http pour récupérer le contenu
      $http({
        method: 'GET',
        url: url,
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
          'Content-Type': 'text/html; charset=utf-8'
        },
        transformResponse: function(data) {
          // On retourne les données brutes sans transformation automatique
          return data;
        }
      }).then(function(response) {
        // Succès : on parse le contenu HTML pour extraire le glossaire
        if (response && response.data) {
          try {
            var termes = parseGlossaireContent(response.data);
            deferred.resolve(termes);
          } catch (error) {
            console.error('Erreur lors du parsing du glossaire:', error);
            deferred.reject('Impossible de parser le contenu du glossaire.');
          }
        } else {
          deferred.reject('Aucune donnée reçue.');
        }
      }).catch(function(error) {
        console.error('Erreur lors de la récupération du glossaire:', error);
        deferred.reject('Impossible de récupérer le contenu du glossaire. Erreur réseau.');
      });

      return deferred.promise;
    }

    /**
     * Parse le contenu HTML pour en extraire les termes du glossaire
     * @param {string} htmlContent Contenu HTML à parser
     * @returns {Array} Tableau d'objets {terme, definition}
     */
    function parseGlossaireContent(htmlContent) {
      // Utiliser une approche simple pour extraire les termes et définitions
      // Note: Cette fonction est simplifiée et pourrait nécessiter des ajustements
      // selon le format exact de la page d'aide

      var termes = [];
      
      // Créer un élément DOM temporaire pour parser le HTML
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;

      // Trouver la section contenant le glossaire
      // Note: Il faudrait adapter cette logique selon la structure réelle de la page
      var glossaireSection = tempDiv.querySelector('#glossaire') || tempDiv.querySelector('.glossaire') || tempDiv;
      
      // Chercher les termes et définitions (supposant une structure DL/DT/DD)
      var termeListes = glossaireSection.querySelectorAll('dl');
      
      if (termeListes && termeListes.length > 0) {
        // Pour chaque liste de définitions
        Array.from(termeListes).forEach(function(liste) {
          var termeElements = liste.querySelectorAll('dt');
          var definitionElements = liste.querySelectorAll('dd');
          
          // Ajout de chaque paire terme/définition
          for (var i = 0; i < termeElements.length; i++) {
            if (termeElements[i] && definitionElements[i]) {
              termes.push({
                terme: termeElements[i].textContent.trim(),
                definition: definitionElements[i].textContent.trim()
              });
            }
          }
        });
      } else {
        // Plan B : chercher des sections avec titre + paragraphe
        var titres = glossaireSection.querySelectorAll('h3, h4, h5');
        
        Array.from(titres).forEach(function(titre) {
          var definition = '';
          var nextElement = titre.nextElementSibling;
          
          // Le paragraphe suivant est probablement la définition
          if (nextElement && nextElement.tagName === 'P') {
            definition = nextElement.textContent.trim();
          }
          
          if (definition) {
            termes.push({
              terme: titre.textContent.trim(),
              definition: definition
            });
          }
        });
      }

      // Si aucun terme trouvé, utiliser des données statiques de démonstration
      if (termes.length === 0) {
        // Utiliser les données statiques comme fallback
        termes = getStaticGlossaireData();
      }

      return termes;
    }

    /**
     * Données de glossaire statiques en cas d'échec du parsing
     * @returns {Array} Tableau d'objets {terme, definition}
     */
    function getStaticGlossaireData() {
      return [
        {
          terme: "Aide Publique au Développement (APD)",
          definition: "L'aide publique au développement (APD) est l'ensemble des aides financières, prêts à taux préférentiels, dons de biens et services, accordés par un pays développé en faveur d'un pays bénéficiaire en développement et qui contribuent au développement économique et à l'amélioration des conditions de vie."
        },
        {
          terme: "Autorisation d'exploitation",
          definition: "Autorisation accordée à une entreprise minière pour exploiter un gisement minier après la phase d'exploration, selon les conditions fixées par les lois et règlements en vigueur."
        },
        {
          terme: "Budget Général de l'État",
          definition: "Document prévisionnel regroupant l'ensemble des recettes et des dépenses de l'État pour une période donnée, généralement un an. Il est voté par l'Assemblée nationale et promulgué par le Chef de l'État sous forme de loi."
        },
        {
          terme: "Contrat pétrolier",
          definition: "Accord contractuel entre l'État et une compagnie pétrolière qui établit les conditions d'exploration et d'exploitation des hydrocarbures, ainsi que le partage des revenus issus de la production."
        },
        {
          terme: "Extractive Industries Transparency Initiative (EITI)",
          definition: "Initiative pour la Transparence dans les Industries Extractives : norme mondiale visant à promouvoir la gestion ouverte et responsable des ressources pétrolières, gazières et minières."
        }
      ];
    }
  }
})();
